import { SVGProps } from 'react';

const SvgImage = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M12.667 3.333v9.334H3.333V3.333h9.334Zm0-1.333H3.333C2.6 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V3.333C14 2.6 13.4 2 12.667 2Zm-3.24 5.907-2 2.58L6 8.76l-2 2.573h8L9.427 7.907Z" />
    </svg>
);
export default SvgImage;
